<template>
    <q-page-sticky position="bottom-right" v-if="merchant && upgrade">
        <q-btn color="amber" size="sm" to="/merchant/plan">
            <q-icon left size="3em"  name="img:/assets/icons/crown-upgrade-dig.svg" />
            <div>Upgrade</div>
        </q-btn>
    </q-page-sticky>
    <q-footer bordered class="bg-white text-primary q-mt-lg">
        <q-tabs 
        switch-indicator
        no-caps
        class="bg-accent text-primary"
        v-model="current">
            <q-route-tab
                v-if="!merchant"
                name="home"
                icon="img:/assets/icons/my-code-icon-dig.svg"
                to="/"
                label="My Code"
                @click="merchant = false"
                exact
            />

            <q-route-tab v-if="merchant"
                name="store"
                icon="img:/assets/icons/scan-icon-dig.svg"
                to="/merchant/scan"
                @click="merchant = true"
                label="Scan"
                exact
            />

            <q-route-tab
                name="history"
                icon="img:/assets/icons/history-icon-dig.svg"
                to="/full-history"
                label="History"
                exact
            />

            <q-btn-dropdown auto-close flat no-caps v-if="merchant" class="q-px-sm">
                <template v-slot:label>
                    <div>
                        <div class="row justify-around items-center no-wrap">
                            <q-icon name="img:/assets/icons/slice2-dig.svg" />
                        </div>
                        <div class="row items-center no-wrap">
                            Business
                        </div>
                    </div>
                </template>

                <q-list class="bg-primary text-white">
                    <q-item active-class="text-black" clickable v-close-popup @click="selectPlace">
                        <q-item-section avatar>
                            <q-icon color="white" name="edit" />
                        </q-item-section>
                        <q-item-label>Edit</q-item-label>
                    </q-item>
                    <q-item active-class="text-black" clickable v-close-popup to="/merchant/plan">
                        <q-item-section avatar>
                            <q-icon color="white" name="list-alt" />
                        </q-item-section>
                        <q-item-label>Plan</q-item-label>
                    </q-item>
                    <q-item active-class="text-black" clickable v-close-popup to="/merchant/billing-history">
                        <q-item-section avatar>
                            <q-icon color="white" name="receipt-long" />
                        </q-item-section>
                        <q-item-label>Subscriptions</q-item-label>
                    </q-item>
                </q-list>
            </q-btn-dropdown>
            
            <q-btn-dropdown auto-close color="primary" flat no-caps v-if="!merchant" class="q-px-sm">
                <template v-slot:label>
                    <div>
                        <div class="row">
                            <q-icon name="img:/assets/icons/slice1-dig.svg" />
                        </div>
                        <div class="row items-center no-wrap">
                            Profile
                        </div>
                    </div>
                </template>

                <q-list class="bg-primary text-white">
                    <q-item active-class="text-black" v-if="!logged" clickable :to="{name: 'User_SignIn'}">
                        <q-item-section avatar>
                            <q-avatar icon="lock-open" text-color="white" />
                        </q-item-section>
                        <q-item-section>Sign In</q-item-section>
                    </q-item>

                    <q-item active-class="text-black" v-if="!logged" clickable :to="{name:'User_SignUp'}">
                        <q-item-section avatar>
                            <q-avatar icon="person-add-alt" text-color="white" />
                        </q-item-section>
                        <q-item-section>Sign Up</q-item-section>
                    </q-item>

                    <q-item active-class="text-black" clickable @click="handleLogout" v-if="logged">
                        <q-item-section avatar>
                            <q-avatar icon="logout" text-color="white" />
                        </q-item-section>
                        <q-item-section>Logout</q-item-section>
                    </q-item>
                </q-list>
            </q-btn-dropdown>

            <q-route-tab
                v-if="merchant"
                name="home"
                label="to Personal"
                icon="img:/assets/icons/switch-personal-icon-dig.svg"
                to="/"
                @click="merchant = false"
                exact
            />

            <q-route-tab v-if="!merchant"
                name="store"
                icon="img:/assets/icons/switch-business-icon-dig.svg"
                to="/merchant/scan"
                label="to Business"
                @click="merchant = true"
                exact
            />
        </q-tabs>
    </q-footer>
</template>
<script>
import router from "@/router";
import { computed, ref } from '@vue/reactivity';
import { inject, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';

export default {
  props: ['current'],
  name: 'bottom-bar',
  setup() {
    const logged = computed(() => store.getters.isAuthenticated)
    const merchant = ref(false)
    const upgrade = ref(true)
    const tab = ref(null)
    const axios = inject('axios')
    const store = useStore()

    function handleLogout() {
      axios.get(`${process.env.VUE_APP_URL}/logout`)
        .then(async resp => {    
          store.commit('setUser', null)
          store.commit('setClearHistory')
          store.commit('clearPlace')
          location.reload()
        })
        .catch(err => {
        })
    }

    const selectPlace = () => {
        let place = store.getters.statePlace.id
        router.push(`/merchant/addplace/${place}`)
    }

    watch(() => router.currentRoute.value, () => {
        if (router.currentRoute.value.fullPath.includes('merchant')) merchant.value = true

        let subscription = localStorage.getItem('subscription')

        if (subscription) upgrade.value = false

    },{immediate:true});
    
    return {logged, handleLogout, merchant, selectPlace, upgrade, tab}
  }
}
</script>
